<div class="row">
  <div class="col-12 offset-lg-2 col-lg-8">
    <div class="row faq faq--row">
      <div class="col-12 faq__intro">
        <h3 class="faq__intro-title"
            *appApplyIfNotEmpty="translationService.getTranslation('faqs_intro')"
            [innerHTML]="translationService.getTranslation('faqs_intro')"></h3>
      </div>
      <div class="col-12 faq__summary">
        <p class="faq__summary-title" [innerHTML]="translationService.getTranslation('faqs_summary')"></p>
      </div>

      @for (group of faqGroups; track group) {
        <app-faqgroup class="faq__group" [faqGroup]="group"></app-faqgroup>
      }
    </div>
  </div>
</div>
